"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CheckIcon = (props) => {
    return (react_1.default.createElement("svg", Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "16", viewBox: "0 0 18 13" }),
        react_1.default.createElement("g", { id: "Group_3330", "data-name": "Group 3330", transform: "translate(2)" },
            react_1.default.createElement("rect", { id: "Rectangle_422", "data-name": "Rectangle 422", width: "18", height: "16", transform: "translate(-2)", fill: "#fff" }),
            react_1.default.createElement("g", { id: "Group_2579", "data-name": "Group 2579", transform: "translate(0 2)" },
                react_1.default.createElement("path", { id: "Path_748", "data-name": "Path 748", d: "M213.637,212.292h0a1.4,1.4,0,0,1,.1,1.895l-8.24,9.762-5.046-5.112a1.4,1.4,0,0,1-.044-1.9h0a1.207,1.207,0,0,1,1.782-.047l3.167,3.209,6.5-7.708A1.209,1.209,0,0,1,213.637,212.292Z", transform: "translate(-200.055 -211.95)", fill: "#2ea0dc" })))));
};
exports.default = CheckIcon;
